import { getAuth } from "../helper/utils/getAuth";
import dayjs from 'dayjs';

export function checkSubscriptionFn(key) {
    const { subscription } = getAuth();

    // following ENG-3279, need to check if features access checking are to follow previous/current plan
    // const { scopes = {} } = subscription || {};

    const {
        previous_plan_valid_until = null,
        previous_plan = {},
        current_plan = {},
        current_addons = {},
        previous_addons = {},
    } = subscription || {};

    let planInUse;
    let addonsInUse;
    if (dayjs().isSameOrBefore(dayjs(previous_plan_valid_until))) {
        planInUse = previous_plan;
        addonsInUse = previous_addons;
    } else {
        planInUse = current_plan;
        addonsInUse = current_addons;
    }

    const { features = {} } = planInUse || {};

    // If the key is MULTI_CURRENCY and the value is false,
    // we check if the addon with type=MULTI_CURRENCY exists,
    // if it does, we return true
    if (key === 'MULTI_CURRENCY' && features[key] === false) {
        const multiCurrencyAddon = Object.values(addonsInUse).find(addon => addon.type === 'MULTI_CURRENCY');
        if (multiCurrencyAddon)
            return true; // Multi-currency addon exists, so we allow access
    }

    // If the key is TAX.SST and the value is false,
    // we check if the addon with type=MALAYSIA_SST exists,
    // if it does, we return true
    if (key === 'TAX.SST' && features[key] === false) {
        const sstAddon = Object.values(addonsInUse).find(addon => addon.type === 'MALAYSIA_SST');
        if (sstAddon)
            return true; // SST addon exists, so we allow access
    }

    // No subscription defined
    if (features[key] === undefined)
        return true;

    // children-level subscope depends on a parent scope
    // eg: parent - PRODUCT
    // eg: child - PRODUCT.GROUP
    // if parent is false, child is false even if explicit value of PRODUCT.GROUP is true
    const subscopes = key?.split('.');
    let hasSubscription;
    let prevSubscope;
    for (const subscopeKey of subscopes) {
        const currentSubscopeKey = prevSubscope ? `${prevSubscope}.${subscopeKey}` : subscopeKey;
        if (planInUse.features[currentSubscopeKey] === undefined) {
            hasSubscription = true;
        }
        else {
            hasSubscription = planInUse.features[currentSubscopeKey];
            if (!hasSubscription)
                return false;
        }

        prevSubscope = currentSubscopeKey;
    }

    return hasSubscription;

    // // No subscription defined
    // if (scopes[key] === undefined)
    //     return true;

    // return scopes[key]; // true or false
}

// OLD (BEFORE changes for ENG-3265)
// import { getAuth } from '../utils/getAuth';

// export function checkSubscriptionFn(key) {
//     const { subscription } = getAuth();
//     const { scopes = {} } = subscription || {};

//     // No subscription defined
//     if (scopes[key] === undefined)
//         return true;

//     // children-level subscope depends on a parent scope
//     // eg: parent - PRODUCT
//     // eg: child - PRODUCT.GROUP
//     // if parent is false, child is false even if explicit value of PRODUCT.GROUP is true
//     const subscopes = key?.split('.');
//     let hasSubscription;
//     let prevSubscope;
//     for (const subscopeKey of subscopes) {
//         const currentSubscopeKey = prevSubscope ? `${prevSubscope}.${subscopeKey}` : subscopeKey;
//         if (scopes[currentSubscopeKey] === undefined) {
//             hasSubscription = true;
//         }
//         else {
//             hasSubscription = scopes[currentSubscopeKey];
//             if (!hasSubscription)
//                 return false;
//         }

//         prevSubscope = currentSubscopeKey;
//     }

//     return hasSubscription;

//     // // No subscription defined
//     // if (scopes[key] === undefined)
//     //     return true;

//     // return scopes[key]; // true or false
// WITH ENG-3265 changes, the above function is no longer used.
// import { getAuth } from '../utils/getAuth';
// import dayjs from 'dayjs';

// export function checkSubscriptionFn(key) {
//     const { subscription } = getAuth();

//     // following ENG-3279, need to check if features access checking are to follow previous/current plan
//     // const { scopes = {} } = subscription || {};

//     const { previous_plan_valid_until = null,
//         previous_plan = {},
//         current_plan = {}}
//          = subscription || {};

//     let planInUse;
//     if (dayjs().isSameOrBefore(dayjs(previous_plan_valid_until)))
//         planInUse = previous_plan;
//     else
//         planInUse = current_plan;

//     // No subscription defined
//     if (planInUse.features[key] === undefined)
//         return true;

//     return planInUse.features[key]; // true or false
// }
